<template>
  <div >
    <el-dialog  title="新增承运商" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"
    :visible="addCYSflag" width="1000px" center  append-to-body>
      <div>
        <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan inpBox" label-width="125px" size="mini">
          <el-form-item label="承运商名称:" prop="customerName">
            <el-input placeholder="" maxlength="30" v-model.trim="addFrom.customerName"
              @blur="nameBlur" ></el-input>
          </el-form-item>
          <div>
            <el-form-item label="企业地址:" prop="locatedIn" class="dizhi">
              <el-input placeholder="" class="disabled" maxlength="300" :readonly="true" v-model="addFrom.locatedIn"></el-input>
              <i class="el-icon-location" @click="dizhiFn"></i>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="联系人:" prop="contactsUser" >
              <el-input placeholder="" maxlength="20" v-model.trim="addFrom.contactsUser"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="contactsMobile">
              <el-input placeholder="" maxlength="11" v-model.trim="addFrom.contactsMobile"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="营业执照:" v-if="addCYSflag">
            <uploadImgs :imgList.sync='imgList' style="margin-top:5px;" @remove='remove'></uploadImgs>
          </el-form-item>
          <div style="margin-top: -20px; margin-left: 30px;font-size: 17px;font-weight: 600;">结算设置</div>
          <div style="margin-top: 20px;">
            <el-form-item label="账期(天):" prop="periodDays" >
              <el-input maxlength="5" v-model.trim="addFrom.periodDays" v-number-input.float="0"></el-input>
            </el-form-item>
            <el-form-item label="账期计算开始日:" prop="periodDaysType">
              <el-select v-model="addFrom.periodDaysType" placeholder="请选择">
                <el-option label="运单开票时间" value="0"></el-option>
                <el-option label="运单创建时间" value="1"></el-option>
                <el-option label="运单签收时间" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="到票期限(天):" prop="invoiceDays" >
              <el-input maxlength="5" v-model.trim="addFrom.invoiceDays" v-number-input.float="0"></el-input>
            </el-form-item>
            <el-form-item label="服务费率(%):" prop="serviceRate">
              <el-input maxlength="5" v-model.trim="addFrom.serviceRate" v-number-input.float="2"></el-input>
            </el-form-item>
            <el-form-item label="运费税率(%):" prop="taxRate" >
              <el-input maxlength="5" v-model.trim="addFrom.taxRate" v-number-input.float="2"></el-input>
            </el-form-item>
            <el-form-item label="支出方式:"  prop="settlementTypeName" >
              <el-select  v-model="addFrom.settlementTypeName"  placeholder="请选择"  >
                <el-option v-for="item in ZCFSlist"  :label="item.showName" :value="item.showName" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-left: 30px;font-size: 17px;font-weight: 600;"  >其他设置</div>
          <div  style="margin-top: 20px;" >
            <el-form-item label="网货承运商:" prop="onlineFlag">
                <el-radio-group v-model="addFrom.onlineFlag" @change="onlineFlagChange">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="运单上报网货:" prop="onlineFreightFlag" v-if="addFrom.onlineFlag==1" >
                <el-radio-group v-model="addFrom.onlineFreightFlag">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="服务费计算:" prop="reverseCountFlag" >
                <el-radio-group v-model="addFrom.reverseCountFlag">
                  <el-radio :label="1">反算</el-radio>
                  <el-radio :label="0">正算</el-radio>
                </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
      <!-- 选择地址 -->
    <mapAddressT :addFrom="addFrom" v-if="dizhiMark" @getAddress="getAddress" @destroy="destroy" ></mapAddressT>
  </div>
</template>

<script>
import { addCustomerInfo, selectCustomerDetail, getDictionaryDetailList } from '@/api/newTMS'
import uploadImgs from '@/components/uploadImgs.vue'
import mapAddressT from '@/components/common/TMSMap.vue'
export default {
  name: 'guanlianhetong',
  components: {
    uploadImgs,
    mapAddressT
  },
  props: {
    addCYSflag: {
      type: Boolean,
      default: false
    },
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      rules: {
        customerName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        // customerTaxId: [
        //   { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        // ],
        periodDays: [
          { required: true, message: '请输入账期', trigger: 'blur' }
        ],
        periodDaysType: [
          { required: true, message: '请选择账期计算开始日', trigger: 'change' }
        ],
        invoiceDays: [
          { required: true, message: '请输入到票期限', trigger: 'blur' }
        ],
        locatedIn: [
          { required: true, message: '请选择企业地址', trigger: 'blur' }
        ],
        contactsUser: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { pattern: this.rule.xingming, message: '联系人必须2-20 个汉字' }
        ],
        contactsMobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: this.rule.shouJiDianHua, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          this.rule.mobile
        ],
        onlineFreightFlag: [
          { required: true, message: '请选择是否网货平台', trigger: 'blur' }
        ],
        contractNo: [
          { required: true, message: '请输入合同编号', trigger: 'blur' }
        ],
        contractStartDate: [
          { required: true, message: '请选择有效开始日期', trigger: 'blur' }
        ],
        contractEndDate: [
          { required: true, message: '请选择有效结束日期', trigger: 'blur' }
        ],
        businessUserCode: [
          { required: true, message: '请选择业务人员', trigger: 'change' }
        ],
        taxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        customerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        loadingVoucher: [
          { required: true, message: '请选择装车凭证是否必填', trigger: 'change' }
        ],
        onlineFlag: [
          { required: true, message: '请选择是否网货承运商', trigger: 'change' }
        ],
        reverseCountFlag: [
          { required: true, message: '请选择是否反算', trigger: 'change' }
        ]

      },
      addFrom: {},
      dizhiMark: false,
      dialogVisible: false,
      ZCFSlist: [],
      imgList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZCFSlist = res })
    this.$set(this.addFrom, 'onlineFlag', 0)
    this.$set(this.addFrom, 'onlineFreightFlag', 0)
    this.$set(this.addFrom, 'reverseCountFlag', 0)
    this.$set(this.addFrom, 'serviceRate', 0)
    this.$set(this.addFrom, 'taxRate', 9)
    this.$set(this.addFrom, 'customerType', 1)
    this.$set(this.addFrom, 'settlementTypeName', '现结')
  },
  methods: {
    // 客户名称失去焦点
    nameBlur () {
      // 调CRM接口，CRM有信息直接填充
      if (this.addFrom.customerType == 1) {
        this.selectCustomerDetail(this.addFrom.customerName)
      }
    },
    selectCustomerDetail (custerName) {
      selectCustomerDetail({
        tenantCode: localStorage.getItem('tenantCode'),
        custerName: custerName
      }).then(res => {
        console.log(JSON.parse(res), '获取客户')
        let resData = JSON.parse(res)
        if (resData.taxpayerNumber) {
          this.addFrom.customerTaxId = resData.taxpayerNumber
          this.disCustomerTaxId = true
          // 只返回legalPerson法人姓名，无电话
        }
        if (resData.address) {
          this.$set(this.addFrom, 'locatedIn', resData.address)
          // 接口未返回省市县数据，点击选择地址无法赋值
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 地址
    dizhiFn () {
      this.dizhiMark = true
    },
    getAddress (data) {
      this.dizhiMark = false
      console.log(data, 'data')
      for (let key in data) {
        this.addFrom[key] = data[key]
      }
    },
    destroy () {
      this.dizhiMark = false
    },
    // 删除图片
    remove (file) {
      console.log(file, 'file')
      this.delImgID = []
      if (file.id) {
        this.delImgID.push(file.id)
      }
    },
    onlineFlagChange (e) {
      if (e == 1) {
        this.$set(this.addFrom, 'onlineFreightFlag', 1)
        this.$set(this.addFrom, 'reverseCountFlag', 1)
      } else {
        this.$set(this.addFrom, 'onlineFreightFlag', 0)
        this.$set(this.addFrom, 'reverseCountFlag', 0)
      }
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.$set(this.addFrom, 'businessType', '2')
          let json = this.ZCFSlist.filter(item => item.showName == this.addFrom.settlementTypeName)
          if (json.length > 0) {
            this.addFrom.settlementType = json[0].itemNo
          }
          let imgfile = new FormData()
          if (this.imgList.length > 0) {
            imgfile.set('files', this.imgList[0].raw)
          }
          imgfile.set('params', JSON.stringify(this.addFrom))
          addCustomerInfo(imgfile).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$emit('update:addCYSflag', false)
            this.$emit('CYSaddFn', { customerName: this.addFrom.customerName })
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    closeDialog () {
      this.$emit('update:addCYSflag', false)
    }

  },
  destroyed () {
  }
}
</script>

<style scoped lang='less'>
.dizhi{
    position: relative;
    .el-icon-location{
     position: absolute;
     right: -30px;
     top: 0;
     font-size: 25px;
     color: #0c46a2;
   }
   /deep/.el-input__inner{
     width: 440px!important;
   }
  }
  /deep/.el-input.is-disabled .el-input__inner {
    color: #606266;
    cursor: not-allowed;
  }
 .imgBox{
   display: flex;
   .item{
     display: flex;
      width: 50%;
      justify-content: space-around;
   }
 }
 /deep/.inpBox .el-input__inner{
   width:180px;
 }
</style>
